import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-dispo-job-list-item-skeleton',
  templateUrl: './dispo-job-list-item-skeleton.component.html',
  styleUrls: ['./dispo-job-list-item-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DispoJobListItemSkeletonComponent {
  @Input() showSkeleton = true;
  @Input() compact = false;
}
